export default __webpack_public_path__ + "static/media/backlessgreen.9624f752.png";